import { CountryFormConfiguration } from "../constants";
import { Malaysia } from "./MY";

export const MalaysiaEN: CountryFormConfiguration = Malaysia("en-MY");
